/**
 * @classdesc
 * Klasse, die die Hintergrundlayer verwaltet und bei Bedarf umschaltet.
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 */
gc.gis.map.GCBackgroundLayerManager = function(options)
{
    gc.gis.GCObservable.call(this);

    /**
     * @private
     * @type {gc.gis.map.GCMapView}
     */
    this._mapView = options.map;

    /**
     * @type {gc.gis.map.GCAbstractMap}
     * @private
     */
    this._map = this._mapView.getMap();

    /**
     * @private
     * @type {gc.gis.map.GCAbstractLayerFactory}
     */
    this._layerFactory = this._map.getLayerFactory();

    /**
     *
     * @private
     * @type {gc.gis.layer.GCAbstractLayer|null}
     */
    this._visibleBackgroundLayer = null;

    this._initEvents();
};
gc.gis.map.GCBackgroundLayerManager.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * @public
 * @return {gc.gis.layer.GCAbstractLayer|null}
 */
gc.gis.map.GCBackgroundLayerManager.prototype.getVisibleBackgroundLayer = function()
{
    return this._visibleBackgroundLayer;
};

gc.gis.map.GCBackgroundLayerManager.prototype._initEvents = function()
{
    const self = this;

    this._mapView.on(gc.gis.map.GCMapEvent.BACKGROUND_LAYER_ADDED, this, function(evt) {
        for (let i = 0; i < evt.layers.length; i++)
        {
            self._registerLayer(evt.layers[i]);
        }
    });

    this._mapView.on(gc.gis.map.GCMapEvent.BACKGROUND_LAYER_REMOVED, this, function(evt) {
        for (let i = 0; i < evt.layers.length; i++)
        {
            self._unregisterLayer(evt.layers[i]);
        }
    });
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.map.GCBackgroundLayerManager.prototype._registerLayer = function(layer)
{
    const self = this;
    this._layerFactory.createLayer(layer);

    layer.on(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self, function(evt) {
        if (evt.newValue) {
            self._setLayerVisible(layer);
        }
        else {
            self._setLayerInvisible(layer);
        }
    });

    if (layer.isVisible())
    {
        this._setLayerVisible(layer);
    }
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.map.GCBackgroundLayerManager.prototype._unregisterLayer = function(layer)
{
    if (layer.isVisible())
    {
        this._setLayerInvisible(layer);
    }

    layer.un(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, this);
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.map.GCBackgroundLayerManager.prototype._setLayerVisible = function(layer)
{
    this._visibleBackgroundLayer = layer;
    this._map.setBackgroundLayer(layer.getImpl());
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.map.GCBackgroundLayerManager.prototype._setLayerInvisible = function(layer)
{
    if (this._visibleBackgroundLayer === layer)
    {
        this._visibleBackgroundLayer = null;
        this._map.removeBackgroundLayer(layer.getImpl());
    }
};